const NS = 'topicDetailsPage';
const CLS = 'TopicDetailsPage';

import 'babel-polyfill';
import 'regenerator-runtime/runtime';

import { fixedScrollMixinPage } from '../../../pages/mixins/fixedScrollMixinPage/fixedScrollMixinPage';

export class TopicDetailsPage {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.initFixedScrollMixin(this, this.$element.children('[data-section-navigator-container]').children().toArray());
	}
}

Object.assign(TopicDetailsPage.prototype, fixedScrollMixinPage);

